import {styled} from "@mui/material/styles";
import {NavLink} from "react-router-dom";

export const CustomNavLink = styled(NavLink)(({ theme }) => ({
    padding: "6px 16px",
    marginInline: "4px",
    textDecoration: "none",
    position: "relative",
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
    opacity: 0.7,
    "&.active": {
        opacity: 1,
    },
    "&:hover": {
        opacity: 1,
    },
    "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        width: "100%",
        height: "3px",
        backgroundColor: theme.palette.primary.main,
        bottom: 0,
        transform: "translateY(5px)",
        opacity: 0,
        transition: "transform 300ms ease, opacity 300ms ease",
    },
    "&:hover::before, &.active::before": {
        transform: "translateY(0)",
        opacity: 1,
    },
}));

